module.exports = __webpack_public_path__ + "market/static/img/box.06c87db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/box.png
// module id = 8OQS
// module chunks = 1